import { useEffect, useRef, useState } from "react"
import { FiHash, FiX } from "react-icons/fi"

export function NewCommandDialog({ open, onClose, onConfirm }) {
  const [code, setCode] = useState('')
  const [loading, setLoading] = useState(false)
  const inputRef = useRef(null)

  useEffect(() => {
    if (!open) {
      setCode('')
      setLoading(false)
      return
    }

    const timer = setTimeout(() => inputRef.current?.focus(), 50)
    return () => clearTimeout(timer)
  }, [open])

  useEffect(() => {
    if (!open) return

    const closeOnEscape = (event) => {
      if (event.key === 'Escape' && !loading) onClose()
    }

    document.addEventListener('keydown', closeOnEscape)
    return () => document.removeEventListener('keydown', closeOnEscape)
  }, [loading, onClose, open])

  if (!open) return null

  async function submit(event) {
    event.preventDefault()
    const normalizedCode = code.trim()
    if (!normalizedCode || loading) return

    try {
      setLoading(true)
      await onConfirm(normalizedCode)
      onClose()
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="new-command-dialog-backdrop" role="presentation" onMouseDown={(event) => {
      if (event.target === event.currentTarget && !loading) onClose()
    }}>
      <form className="new-command-dialog" role="dialog" aria-modal="true" aria-labelledby="newCommandDialogTitle" onSubmit={submit}>
        <div className="new-command-dialog-handle" />
        <header>
          <span><FiHash size={19} /></span>
          <div>
            <h2 id="newCommandDialogTitle">Nova comanda</h2>
            <p>Informe o código que identificará a comanda.</p>
          </div>
          <button type="button" aria-label="Fechar" onClick={onClose} disabled={loading}><FiX size={20} /></button>
        </header>

        <div className="new-command-dialog-body">
          <label htmlFor="newCommandCode">Código da comanda</label>
          <input ref={inputRef} id="newCommandCode" maxLength={100} value={code} onChange={(event) => setCode(event.target.value)} placeholder="Ex: 12, A15 ou nome do cliente" autoComplete="off" />
        </div>

        <footer>
          <button type="button" className="secondary" onClick={onClose} disabled={loading}>Cancelar</button>
          <button type="submit" className="primary" disabled={!code.trim() || loading}>{loading ? 'Criando...' : 'Criar comanda'}</button>
        </footer>
      </form>
    </div>
  )
}
